<template>
	<div>
		<v-row no-gutters>
			<v-col cols="8" class="pl-5 mt-5">
				<VueFileAgent
					ref="vueFileAgent"
					:theme="'list'"
					:multiple="true"
					:deletable="true"
					:meta="true"
					:accept="'image/*,.pdf,.doc,.docx'"
					:maxSize="'50MB'"
					:maxFiles="15"
					:helpText="$gettext('Drag or click here to upload documents')"
					:errorText="{
						type: 'Invalid file type. Only images and PDFs are allowed',
						size: 'Files cannot exceed 50MB in size'
					}"
					@select="filesSelected($event)"
					@beforedelete="onBeforeDelete($event)"
					v-model="fileRecords"
				></VueFileAgent>
			</v-col>
			<v-col cols="4" class="pr-5 mt-5 pl-2 pt-1">
				<div v-for="(file, i) in fileRecords" :key="i">
					<v-text-field
						height="57"
						:rules="descriptionRules"
						:placeholder="$gettext('Description')"
						v-model="fileNotes[i]"
						filled
						hide-details
					></v-text-field>
				</div>
			</v-col>
			<v-col cols="12" class="px-5 mt-3">
				<v-row no-gutters>
					<v-spacer></v-spacer>
					<v-btn :disabled="!fileRecordsForUpload.length || disabled" @click="uploadFiles()" color="primary" class="ml-3 mb-2" :loading="saving">
						<translate>Add</translate>
					</v-btn>
				</v-row>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12" class="px-5">
				<DocumentsList :documents="documents" :disable="disabled" />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DocumentsList from "@/components/appointment/anamnesis/DocumentsList.vue";
import axios from "axios";

export default {
  name: "Documents",
	props: ["documents", "disabled"],
	components: {
		DocumentsList
	},
	data: () => ({
		fileNotes: [],
		saving: false,
		valid: true,
		fileRecords: [],
		fileRecordsForUpload: []
  }),
  computed: {
		descriptionRules() {
			return [v => !!v || this.$gettext("Description is required")];
		}
  },
  methods: {
		uploadFiles() {
			this.saving = true;
			const patientId = this.$route.params.pid;
      const appointmentId = this.$route.params.aid;
			const formData = new FormData();
			for(let i = 0; i < this.fileRecordsForUpload.length; i++) {
				formData.append("attachment" + i, this.fileRecordsForUpload[i].file);
				if(this.fileNotes[i]) formData.append("attachment_description" + i, this.fileNotes[i]);
				else formData.append("attachment_description" + i, "");
			}
			axios
				.post(
					"/patient/" + patientId + "/appointment/" + appointmentId + "/upload-files",
					formData
				)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						if (response.data.result === "added") {
							let uploadedDocuments = response.data.documents;
							for(let i=0; i < uploadedDocuments.length; i++) {
								this.documents.push(uploadedDocuments[i]);
							}
							this.saving = false;
							this.fileRecords = [];
							this.fileRecordsForUpload = [];
							this.fileNotes = [];
						} else {
							this.saving = false;
						}
					}
				})
				.catch(error => {
					console.log(error);
					this.saving = false;
				});
    },
    filesSelected(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
		},
		onBeforeDelete(fileRecord) {
			var h = this.fileRecords.indexOf(fileRecord);
      if (h !== -1) {
				this.fileRecords.splice(h, 1);
				this.fileNotes.splice(h, 1);
			}
			var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
				this.fileRecordsForUpload.splice(i, 1);
			}
    },
    validate() {
      return this.$refs.form.validate();
		},
    addDocument() {
			if (this.validate()) {
				this.saving = true;
        const patientId = this.$route.params.pid;
        const appointmentId = this.$route.params.aid;
				const formData = new FormData();
				formData.append("attachment", this.document);
				formData.append("attachment_description", this.documentNotes);
				formData.append("complaint_submit", true);
				axios
					.post(
						"/patient/" + patientId + "/appointment/" + appointmentId,
						formData
					)
					.then(response => {
						console.log(response.data);
						if (response.status === 200) {
							if (response.data.result === "added") {
								this.documents.push(response.data.document);
								this.saving = false;
							}
						}
					})
					.catch(error => {
						console.log(error);
						this.saving = false;
					});
			}
    }
  }
};
</script>